import { default as RDatePicker } from 'react-datepicker'

import styled from '@emotion/styled'

const StyledDatePicker = styled(RDatePicker)`
  width: 100%;
  font-weight: ${(p) => (p.fontWeight ? p.fontWeight : 600)};
  font-size: 14px;
  color: ${(p) => (p.disabled ? 'rgba(0,0,0,0.5)' : '#000')};
  border: 2px solid
    ${(p) =>
      p.valid
        ? '#2BD2B4'
        : p.isInvalid
        ? '#D01030'
        : p.borderColor ?? '#9FB8E5'};
  min-height: 48px;
  border-radius: 6px;
  padding-inline-start: 16px;
  padding-inline-end: 16px;
  background-color: white;

  ::placeholder {
    font-size: 14px;
    color: #2d2e41;
    opacity: 30%;
    font-style: italic;
    font-weight: 500;
  }
`

interface DatePickerIProps {
  date: Date
  name: string
  minDate?: Date
  maxDate?: Date
  popperPlacement?: string
  onChange: (date: Date) => void
  isDisabled?: boolean
  placeholder?: string

  [key: string]: unknown
}

export const DatePicker = ({
  date,
  minDate = new Date(),
  maxDate,
  popperPlacement = 'bottom',
  onChange,
  placeholder,
  isDisabled,
  ...rest
}: DatePickerIProps) => {
  return (
    <StyledDatePicker
      {...rest}
      dateFormat='MMMM dd, yyyy'
      disabled={isDisabled}
      maxDate={maxDate}
      minDate={minDate}
      onChange={onChange}
      placeholder={placeholder}
      popperPlacement={popperPlacement}
      selected={date}
    />
  )
}
